export default "__VITE_ASSET__BAWR$fE5__"